<template>
    <v-navigation-drawer v-model="drawer" app dark fixed permanent :mini-variant.sync="mini" expand-on-hover
        color="sidebar" class="redesign-sidebar admin-sidebar">
        <template v-slot:prepend>
            <div class="sidebar-logo">
                <img class="logo-img logo-mini" :class="{ 'logo-visible': mini }"
                    :src="require('@/assets/img/brand_mark.png')" alt="" />
                <img class="logo-img logo-full" :class="{ 'logo-visible': !mini }"
                    :src="require('@/assets/img/logo_sidebar.png')" alt="" />
            </div>
        </template>

        <v-list nav class="py-2">
            <v-list-item :to="{ name: 'admin.home' }" exact link class="nav-item">
                <v-list-item-icon>
                    <v-icon size="20">mdi-view-grid-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title class="list-title">Panel</v-list-item-title>
            </v-list-item>

            <v-list-group v-for="section in sections" :key="section.name" :value="isSectionOpen(section)"
                @input="onSectionChange(section, $event)" class="nav-group" color="transparent"
                :class="{ 'nav-group--current': isSectionCurrent(section) }">
                <template v-slot:activator>
                    <v-list-item-icon>
                        <v-icon size="20">{{ section.icon }}</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title class="list-title">{{ section.name }}</v-list-item-title>
                </template>

                <v-list-item v-for="item in section.items" :key="item.title" :to="item.link" link
                    class="nav-item nav-item--child">
                    <v-list-item-icon>
                        <v-icon size="18">{{ item.icon }}</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title class="list-title">{{ item.title }}</v-list-item-title>
                </v-list-item>
            </v-list-group>
        </v-list>

        <template v-slot:append>
            <v-list nav class="py-2">
                <v-list-item :to="homeRoute" link class="nav-item">
                    <v-list-item-icon>
                        <v-icon size="20">$home</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title class="list-title">Volver a la app</v-list-item-title>
                </v-list-item>

                <v-list-item link class="nav-item" @click="logout">
                    <v-list-item-icon>
                        <v-icon size="20">$logout</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title class="list-title">Cerrar sesión</v-list-item-title>
                </v-list-item>

                <v-list-item v-if="account" class="account-item">
                    <v-list-item-icon>
                        <div class="sidebar-avatar">{{ initials }}</div>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title class="sidebar-account-name">{{ account.name }}</v-list-item-title>
                        <v-list-item-subtitle class="sidebar-account-email">{{ account.email }}</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </template>
    </v-navigation-drawer>
</template>

<script>
import { logout } from '@/utils/Session'
import { getInitials } from '@/utils/Common'

export default {
    name: 'AdminNavigationDrawer',
    data() {
        return {
            drawer: false,
            mini: true,
            openSections: [],
            scrollPosition: 0,
            sections: [
                {
                    name: 'Cuentas',
                    icon: 'mdi-account-group-outline',
                    items: [
                        { title: 'Ficha de usuario', icon: 'mdi-card-account-details-outline', link: { name: 'admin.user-detail' } },
                        { title: 'Confirmar email', icon: 'mdi-email-check-outline', link: { name: 'admin.confirm-email' } },
                        { title: 'Enlazar usuarios', icon: 'mdi-account-multiple-plus-outline', link: { name: 'admin.attach-users' } },
                        { title: 'Accesos', icon: 'mdi-key-outline', link: { name: 'admin.user-access' } },
                        { title: 'Invitaciones', icon: 'mdi-email-fast-outline', link: { name: 'admin.invitations' } },
                        { title: 'Empresa a entrenador', icon: 'mdi-office-building-remove-outline', link: { name: 'admin.company-to-coach' } },
                        { title: 'Restaurar cuenta', icon: 'mdi-account-reactivate-outline', link: { name: 'admin.restore-user' } },
                        { title: 'Borrar usuario', icon: 'mdi-account-remove-outline', link: { name: 'admin.delete-user' } },
                    ],
                },
                {
                    name: 'Contenido',
                    icon: 'mdi-folder-outline',
                    items: [
                        { title: 'Subir ejercicios', icon: 'mdi-file-upload-outline', link: { name: 'admin.excel' } },
                        { title: 'Encuestas', icon: 'mdi-poll', link: { name: 'admin.surveys' } },
                    ],
                },
                {
                    name: 'Sistema',
                    icon: 'mdi-cog-outline',
                    items: [
                        { title: 'Errores', icon: 'mdi-bug-outline', link: { name: 'admin.errors' } },
                        { title: 'Configuración', icon: 'mdi-tune', link: { name: 'admin.config' } },
                        { title: 'Tutoriales', icon: 'mdi-play-circle-outline', link: { name: 'admin.tutorials' } },
                    ],
                },
            ],
        }
    },
    computed: {
        initials(vm = this) {
            return getInitials(vm.account?.name || vm.account?.email || '')
        },
        currentSection(vm = this) {
            return vm.sections.find(section => section.items.some(item => item.link.name === vm.$route.name)) || null
        },
        homeRoute(vm = this) {
            switch (vm.account?.accountType) {
                case 'student':
                    return { name: 'student.home' }
                case 'coach':
                case 'coach_company':
                    return { name: 'coach.home' }
                case 'company':
                    return { name: 'company.home' }
                default:
                    return { name: 'splash' }
            }
        }
    },
    created() {
        const vm = this
        vm.openSections = vm.currentSection ? [vm.currentSection.name] : []
    },
    methods: {
        isSectionOpen(section) {
            return this.openSections.includes(section.name)
        },
        isSectionCurrent(section) {
            return this.currentSection?.name === section.name
        },
        onSectionChange(section, open) {
            const vm = this
            if (open === vm.openSections.includes(section.name)) return
            vm.openSections = open
                ? [...vm.openSections, section.name]
                : vm.openSections.filter(name => name !== section.name)
        },
        async logout() {
            await logout(this.$router)
        },
    },
    watch: {
        '$route.name'() {
            const vm = this
            if (vm.currentSection) vm.openSections = [vm.currentSection.name]
        },
        mini(value) {
            const vm = this
            const content = vm.$el?.querySelector('.v-navigation-drawer__content')
            if (!content) return
            if (value) return vm.scrollPosition = content.scrollTop
            vm.$nextTick(() => content.scrollTop = vm.scrollPosition)
        },
    }
}
</script>

<style scoped>
.sidebar-logo {
    position: relative;
    height: 34px;
    margin: 12px 16px 6px;
}

.logo-img {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    margin: auto 0;
    opacity: 0;
    transition: opacity 0.16s ease;
    pointer-events: none;
    height: auto;
}

.logo-img.logo-visible {
    opacity: 1;
}

.logo-mini {
    height: 30px;
    width: auto;
}

.logo-full {
    height: 30px;
    width: auto;
}

.nav-group ::v-deep .v-list-group__header {
    border-radius: 8px;
    min-height: 40px;
    margin-bottom: 2px;
    color: #3A4558;
}

.nav-group ::v-deep .v-list-group__header .v-icon {
    color: #3A4558;
}

.nav-group ::v-deep .v-list-group__header:hover {
    background: #1A1E27;
}

.nav-group ::v-deep .v-list-group__header:hover,
.nav-group ::v-deep .v-list-group__header:hover .v-icon {
    color: #8892A4;
}

.nav-group ::v-deep .v-list-group__header::before {
    opacity: 0 !important;
}

.nav-group ::v-deep .v-list-group__header__append-icon .v-icon {
    font-size: 18px;
}

/* el grupo abierto no es "activo": solo lo son los items */
.nav-group ::v-deep .v-list-group__header.v-list-item--active,
.nav-group ::v-deep .v-list-group__header.v-list-item--active .v-icon {
    color: #3A4558 !important;
}

.nav-group ::v-deep .v-list-group__header.v-list-item--active::after {
    display: none;
}

.nav-item--child {
    padding-left: 22px !important;
}

/* colapsado: nada de subitems corridos ni cortados (al hover el drawer se expande) */
.admin-sidebar.v-navigation-drawer--mini-variant ::v-deep .v-list-group__items {
    display: none;
}

/* colapsado: el grupo toma el estado activo del subitem, que no se ve */
.admin-sidebar.v-navigation-drawer--mini-variant ::v-deep .nav-group--current .v-list-group__header,
.admin-sidebar.v-navigation-drawer--mini-variant ::v-deep .nav-group--current .v-list-group__header .v-icon {
    color: #F0F2F5 !important;
}

.admin-sidebar.v-navigation-drawer--mini-variant ::v-deep .nav-group--current .v-list-group__header::after {
    content: '';
    display: block;
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 3px;
    height: 22px;
    background: var(--brand-gradient);
    border-radius: 0 3px 3px 0;
}

.admin-sidebar ::v-deep .v-navigation-drawer__content::-webkit-scrollbar {
    width: 4px;
}

.admin-sidebar ::v-deep .v-navigation-drawer__content::-webkit-scrollbar-thumb {
    background: #2A3040;
    border-radius: 4px;
}

.admin-sidebar ::v-deep .v-navigation-drawer__content::-webkit-scrollbar-track {
    background: transparent;
}

.list-title {
    font-weight: 500;
    font-size: 13px;
    line-height: 17px;
}

.nav-item {
    border-radius: 8px;
    margin-bottom: 2px;
    min-height: 40px;
    color: #3A4558;
}

.nav-item ::v-deep .v-list-item__icon {
    margin-top: 9px;
    margin-bottom: 9px;
    margin-right: 10px;
}

.nav-item ::v-deep .v-icon {
    color: #3A4558;
}

.nav-item:hover {
    background: #1A1E27;
}

.nav-item:hover,
.nav-item:hover ::v-deep .v-icon {
    color: #8892A4;
}

.admin-sidebar ::v-deep .nav-item.v-list-item--active {
    color: #F0F2F5 !important;
}

.admin-sidebar ::v-deep .nav-item.v-list-item--active .v-icon {
    color: #F0F2F5 !important;
}

.admin-sidebar ::v-deep .v-list-item--active::before {
    opacity: 0;
}

.admin-sidebar ::v-deep .nav-item.v-list-item--active::after {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 3px;
    height: 22px;
    background: var(--brand-gradient);
    border-radius: 0 3px 3px 0;
}

.account-item {
    min-height: 48px;
    height: 48px;
    margin-top: 4px;
}

.account-item ::v-deep .v-list-item__icon {
    margin: 0 10px 0 0;
    min-width: 28px;
    height: 28px;
    align-self: center;
}

.account-item ::v-deep .v-list-item__content {
    padding: 0;
    align-self: center;
}

.sidebar-avatar {
    flex: 0 0 28px;
    width: 28px;
    height: 28px;
    min-width: 28px;
    border-radius: 50%;
    background: var(--brand-gradient);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 11px;
    font-weight: 600;
    color: #0C0E12;
}

.sidebar-account-name {
    font-size: 12px;
    font-weight: 600;
    color: #C9D1DC;
}

.sidebar-account-email {
    font-size: 11px;
    color: #5A6677;
}
</style>
